"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const englishTranslation = {
    personalizeTitle: 'Personalization',
    personalizePopoverButtonLabel: 'Need more information?',
    personalizeButtonText: 'Personalize',
    personalizePopoverText: 'Personalization applies to quantity selected.',
    personalizeAnotherButtonText: 'Personalize Another',
    personalizeAnotherPopoverText: 'Duplicate this product with a different personalization.',
    personalizeAddAgainButtonText: 'Add Item Again',
    personalizeAddAgainPopoverText: 'Duplicate this product without personalization.',
    personalizeShippingLabel: 'Shipping Info',
    personalizeStyleLabel: 'Style',
    personalizeFontStyleLabel: 'Font Style',
    personalizeScriptLabel: 'Script',
    personalizeBlockLabel: 'Block',
    personalizeTextLabel: 'Text',
    personalizeLine1Label: 'Line 1',
    personalizeLine2Label: 'Line 2',
    personalizeOptionalLabel: 'optional',
    personalizeDifferentText: 'Want this Bible with a different name?',
    personalizeUnitPriceLabel: 'Unit Price',
    personalizeRemoveLink: 'Remove',
    personalizeEditLink: 'Edit',
    personalizeModalTitle: 'Personalize Your Bible',
    personalizeModalCloseButtonLabel: 'Close',
    personalizeModalPriceNote: '$6.99 per item. Applies to quantity selected.',
    personalizeModalDisclaimerLabel: 'Disclaimer',
    personalizeModalDisclaimerText: 'Personalized items cannot be returned or refunded. Fonts as displayed are a general representation and may vary. Color will be automatically selected for best match.',
    personalizeModalDisclaimerAgreeLabel: 'I agree to the disclaimer.*',
    personalizeModalRequireLabel: '* required field',
    personalizeModalConfirmButtonText: 'Confirm Personalization',
};
exports.default = englishTranslation;
